import { createFileRoute } from "@tanstack/react-router";
import { StbTcoCalculatorPage } from "@/components/tools/StbTcoCalculatorPage";
import { stbTcoCalculatorSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/tools/stb-tco-calculator")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => stbTcoCalculatorSeo(loaderData?.href ?? "/tools/stb-tco-calculator"),
  component: StbTcoCalculatorPage,
});
